document.addEventListener('DOMContentLoaded', function () {

  function syncDownpayShippingProperty() {

    const selected = document.querySelector(
      'input[name="purchase_option"]:checked'
    );

    // Main product forms only — ignore installment/payment forms
    const productForms = document.querySelectorAll(
      'form[action*="/cart/add"]:not(.installment)'
    );

    productForms.forEach(function (form) {

      // Only touch forms that actually contain the main product variant input
      if (!form.querySelector('.product-variant-id')) {
        return;
      }

      let input = form.querySelector(
        'input[name="properties[Preorder]"]'
      );

      // Always create the property
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[Preorder]';
        form.appendChild(input);
      }

      // Set the value depending on the Downpay choice
      if (
        selected &&
        selected.value === 'purchase_option_pay_deposit'
      ) {
        input.value = 'Deposit';
      } else {
        input.value = 'Pay in Full';
      }

    });

  }

  // Update whenever customer changes Downpay option
  document.addEventListener('change', function (event) {

    if (event.target.name === 'purchase_option') {
      syncDownpayShippingProperty();
    }

  });

  // Initial sync after Downpay has loaded
  setTimeout(syncDownpayShippingProperty, 500);

});